import { render } from "./CaptionsPreviewPlayer.vue?vue&type=template&id=bf29870e"
import script from "./CaptionsPreviewPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./CaptionsPreviewPlayer.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Captioning/CaptionsPreviewPlayer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf29870e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf29870e', __exports__)) {
    api.reload('bf29870e', __exports__)
  }
  
  module.hot.accept("./CaptionsPreviewPlayer.vue?vue&type=template&id=bf29870e", () => {
    api.rerender('bf29870e', render)
  })

}


export default __exports__